(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["leslis-gewaehrleistung-dialog"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('leslis-guarantee-dialog')) {
    customElements.define('leslis-guarantee-dialog', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.closeButton = this.querySelector('[data-leslis-guarantee-close]');
        this.viewButton = this.querySelector('[data-leslis-guarantee-view]');
        this.scrollArea = this.querySelector('[data-leslis-guarantee-scroll]');
        document.addEventListener('click', (event) => {
          const opener = event.target instanceof Element ? event.target.closest('[data-leslis-guarantee-open]') : null;
          if (!opener || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.open(opener);
        }, options);
        this.closeButton.addEventListener('click', () => this.dialog.close(), options);
        this.viewButton.addEventListener('click', () => {
          const fit = this.dialog.toggleAttribute('data-fit');
          this.viewButton.setAttribute('aria-pressed', String(!fit));
          this.viewButton.textContent = fit ? this.viewButton.dataset.readLabel : this.viewButton.dataset.fitLabel;
          this.scrollArea.scrollTo(0, 0);
        }, options);
        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.suppressEscapeKeyup = true;
          this.dialog.close();
        }, options);
        document.addEventListener('keydown', (event) => {
          if (!this.dialog.open || event.key !== 'Escape') return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.suppressEscapeKeyup = true;
          this.dialog.close();
        }, { ...options, capture: true });
        document.addEventListener('keyup', (event) => {
          if (event.key !== 'Escape' || (!this.dialog.open && !this.suppressEscapeKeyup)) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.suppressEscapeKeyup = false;
        }, { ...options, capture: true });
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => this.restore(), options);
      }

      open(opener) {
        if (this.dialog.open) return;
        this.opener = opener;
        this.previousDialog = opener.closest('[role="dialog"][open], dialog[open]');
        window.theme?.a11y?.removeTrapFocus();
        this.dialog.showModal();
        document.documentElement.classList.add('leslis-guarantee-is-open');
        this.dialog.removeAttribute('data-fit');
        this.viewButton.setAttribute('aria-pressed', 'true');
        this.viewButton.textContent = this.viewButton.dataset.fitLabel;
        this.scrollArea.scrollTo(0, 0);
        this.closeButton.focus({ preventScroll: true });
      }

      restore() {
        document.documentElement.classList.remove('leslis-guarantee-is-open');
        const previous = this.previousDialog;
        const opener = this.opener?.isConnected ? this.opener : previous?.querySelector('[data-leslis-guarantee-open]');
        if (previous?.isConnected && previous.hasAttribute('open') && !previous.hidden) {
          const focusTarget = opener || previous.querySelector('button');
          if (focusTarget) window.theme?.a11y?.trapFocus(previous, focusTarget);
        } else if (!previous && opener) {
          opener.focus({ preventScroll: true });
        }
      }

      disconnectedCallback() {
        this.abortController?.abort();
        if (this.dialog?.open) {
          this.dialog.close();
          this.restore();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
